import { FelaCSS } from '../../components/fela/flowtypes';
import { IStylingProps } from '../../themes/types';
import { TColor } from '../../types';
import IconWrap from './icon-wrap';

interface IProps extends IStylingProps {
  id?: string;
  color?: TColor;
  width?: number;
  style?: FelaCSS;
}

interface IconTypes {
  iconColor: string;
  width: number;
  height: number;
}

const IconPound = ({ id, color, width = 79, style, ...restProps }: IProps) => {
  const viewBoxWidth = 79;
  const viewBoxHeight = 109;

  const icon = ({ iconColor, width, height }: IconTypes) => (
    <svg
      id={id}
      viewBox={`0 0 ${viewBoxWidth} ${viewBoxHeight}`}
      width={`${width}px`}
      height={`${height}px`}>
      <path
        fill={iconColor}
        d="M72.836 93.05c1.7 0 3.15.6 4.35 1.8 1.2 1.1 1.8 2.5 1.8 4.2 0 2.3-1.15 4.1-3.45 5.4-4.9 2.7-10.2 4.05-15.9 4.05-2.8 0-5.25-.3-7.35-.9-2-.5-4.5-1.3-7.5-2.4-2.8-1.1-5.3-1.95-7.5-2.55-2.1-.6-4.6-.9-7.5-.9-5.8 0-11.2 1.7-16.2 5.1-1.1.8-2.25 1.2-3.45 1.2-1.5 0-2.8-.5-3.9-1.5-1.1-1.1-1.65-2.35-1.65-3.75 0-1.9.7-3.45 2.1-4.65 3.8-3.6 7.05-8 9.75-13.2 2.7-5.2 4.05-10.6 4.05-16.2 0-1.9-.15-3.75-.45-5.55H5.486c-1.5 0-2.8-.5-3.9-1.5-1-1.1-1.5-2.4-1.5-3.9s.5-2.8 1.5-3.9c1.1-1.1 2.4-1.65 3.9-1.65h11.85c-1.5-4.6-2.6-8.3-3.3-11.1-.7-2.9-1.05-6.05-1.05-9.45 0-9.6 3.3-17.15 9.9-22.65 6.7-5.5 15.55-8.25 26.55-8.25 7.4 0 14.6 1.45 21.6 4.35 3 1.2 4.5 3.2 4.5 6 0 1.8-.6 3.3-1.8 4.5-1.2 1.2-2.7 1.8-4.5 1.8-.7 0-1.65-.2-2.85-.6-5.9-1.9-11.35-2.85-16.35-2.85-8.5 0-14.55 1.65-18.15 4.95-3.5 3.3-5.25 7.35-5.25 12.15 0 2.5.3 5.1.9 7.8.6 2.7 1.5 5.95 2.7 9.75l1.05 3.6h25.05c1.5 0 2.8.55 3.9 1.65 1.1 1.1 1.65 2.4 1.65 3.9 0 1.6-.55 2.9-1.65 3.9-1 1-2.3 1.5-3.9 1.5h-22.65c.2 2 .3 3.55.3 4.65 0 7.7-2.1 14.85-6.3 21.45l3.75-.15c2.6 0 4.9.25 6.9.75 2.1.5 4.95 1.3 8.55 2.4 2.8 1 5.25 1.75 7.35 2.25 2.2.5 4.45.75 6.75.75 3.2 0 6.35-.55 9.45-1.65 1.2-.4 2-.6 2.4-.6z"
      />
    </svg>
  );

  return (
    <IconWrap
      icon={icon}
      color={color}
      width={width}
      viewBoxWidth={viewBoxWidth}
      viewBoxHeight={viewBoxHeight}
      style={style}
      {...restProps}
    />
  );
};

export default IconPound;
